import {MEDIA_SERVER} from "../constants/GlobalConst";
import {refresh} from "../services/auth/AuthAxios";
import createAuthenticatedAxios from "./createAuthenticatedAxios";

export const mediaAxios=createAuthenticatedAxios({
  baseURL:MEDIA_SERVER,refreshSession:refresh,refreshErrorMessage:'사용자 인증 갱신에 실패했습니다.',
  toSession:data=>({id:data.id,username:data.username,role:data.role,name:data.name,accessToken:data.token.accessToken,refreshToken:data.token.refreshToken,serverName:''}),
});
